import { IConnectorList } from '../../../models';
import connectorLogo from '../assets/Connector.png';
import ConnectorConfigs from './ConnectorConfigs';

export const getConnectorImageDetails = (connector?: IConnectorList) => {
  if (!connector) {
    return '';
  }
  const name = connector.connectorName.toLowerCase().replace(/ /g, '');
  if (ConnectorConfigs[name]) {
    return (ConnectorConfigs[name].img);
  }
  const connectorConfigKeys = Object.keys(ConnectorConfigs);
  const val = connectorConfigKeys.find((k) => connector.connectorDescription.toLowerCase().includes(k));
  if (val) {
    return (ConnectorConfigs[val].img);
  }
  return connectorLogo;
};
